import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import {
  decimalInvertedReportFormatter,
  percentageReportFormatter,
} from "../../fomatters/DecimalFormatter";
import InputSelect from "../InputSelect";
import InputSelectGame from "../InputSelectGame";
import Report from "../Report";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setDate(currentDate.getDate() + 1);

const startDateValue = new Date().toISOString().split("T")[0];
const endDateValue = currentDate.toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function StatisticsByGame() {
  const [endDate, setEndDate] = useState(endDateValue);

  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback((event) => {
    setStartDate(event.target.value);

    const endDateChanged = new Date(event.target.value);
    endDateChanged.setDate(endDateChanged.getDate() + 1);
    setEndDate(endDateChanged.toISOString().split("T")[0]);
  }, []);

  const [wagerStatus, setWagerStatus] = useState(0);
  const onWagerStatusChanged = useCallback(
    (event) => setWagerStatus(Number(event.target.value)),
    []
  );

  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [idGame, setIdGame] = useState(0);
  const onGameChanged = useCallback((g) => setIdGame(g), []);

  const [orderBy, setOrderBy] = useState(0);
  const onOrderByChanged = useCallback(
    (event) => setOrderBy(Number(event.target.value)),
    []
  );

  const [groupBy, setGroupBy] = useState(0);
  const onGroupByChanged = useCallback(
    (event) => setGroupBy(Number(event.target.value)),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [office, setOffice] = useState("");
  const onOfficeChanged = useCallback((o) => setOffice(o), []);
  const { values: offices } = useDataFormatterHook({
    addEmpty: true,
    value: "officeName",
    text: "officeName",
    path: `/Player/Office_GetList`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="Game Date"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Office"
          name="name"
          data={offices}
          placeholder="DataFormatter"
          setSelectValue={onOfficeChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <InputSelectGame
          startDate={startDate}
          endDate={endDate}
          setSelectValue={onGameChanged}
        />
        <div>
          <SubGroup title="Group By">
            <FormControl component="fieldset">
              <RadioGroup label value={groupBy} onChange={onGroupByChanged} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="None"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Office"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Player"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
        <div>
          <SubGroup title="Order By">
            <FormControl component="fieldset">
              <RadioGroup label value={orderBy} onChange={onOrderByChanged} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="None"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Period"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Play"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />
      </div>
      <Report
        exportCSV={false}
        groupBy="groupBy"
        title="Statistics by Game Report"
        getUrl={() => "/Reports/Report_Game_Statistics_Per_Game_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          Office: office,
          Book: book,
          IdGame: idGame,
          OrderBy: orderBy,
          GroupBy: groupBy,
          Distributor: distributor,
        })}
        getPreProcess={(data) =>
          data
            .filter(({ group1 }) => group1 !== null)
            .map((item) => {
              const groupByValue = item.groupBy ? `${item.groupBy} ` : "";
              const group1 = item.group1 ? ` ${item.group1}` : "";
              const group2 = item.group2 ? ` ${item.group2}` : "";

              return {
                ...item,
                groupBy: `${groupByValue}${group1}${group2}`,
              };
            })
        }
        getProcess={(data) =>
          data.map((item) => ({
            ...item,
            holdPercentage:
              Math.round(
                (item.winLost / item.amount + Number.EPSILON) * 10000
              ) / 100,
          }))
        }
        getTotals={(data) => {
          const amount = data.reduce((acc, item) => acc + item.amount, 0);
          const winLost = data.reduce((acc, item) => acc + item.winLost, 0);

          return {
            play: "Sub Total",
            amount,
            winLost,
            holdPercentage:
              Math.round((winLost / amount + Number.EPSILON) * 10000) / 100,
          };
        }}
        getGlobalTotals={(data) => {
          const amount = data.reduce((acc, item) => acc + item.amount, 0);
          const winLost = data.reduce((acc, item) => acc + item.winLost, 0);

          return {
            play: "Sub Total",
            amount,
            winLost,
            holdPercentage:
              Math.round((winLost / amount + Number.EPSILON) * 10000) / 100,
          };
        }}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="group3">
          Play
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="amount"
          dataFormat={decimalInvertedReportFormatter}
        >
          Risk
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="winLost"
          dataFormat={decimalInvertedReportFormatter}
        >
          Win / Lost
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="holdPercentage"
          dataFormat={percentageReportFormatter}
        >
          HoldPct
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default StatisticsByGame;
